<template>
    <div class="cart" :class="{'cartHeight': !shops.length}">
        <Head
            :headInfo='headInfo'
            :leftArrowShow='false'
            @onClickRight='onEdit'
        />
        <div class="cart_list" v-if="shops.length">
            <div class="cart_list_item" v-for="(shop, shopIndex) in shops" :key='shop.id'>
                <div class="cart_list_item_li">
                    <div class="topHead">
                        <van-checkbox checked-color='#FF7A45' @click="selectAll(shop)" v-model="isShopSelectedAll[shops.indexOf(shop)]">
                            <i class="iconfont iconicon_dianpu"></i>{{ shop.shopName }}
                        </van-checkbox>
                    </div>
                    <div class="goodItem" v-for="(good, goodIndex) in shop.skus" :key="good.id">
                        <van-swipe-cell :rightWidth='130'>
                            <GoodTemplate @onDialog='onDialog(good, shopIndex, goodIndex)' @onDetail='onDetail(good.spuId)'  @sumCartPrice='sumCartPrice(good)' :shop='shop' :good='good' />
                            <template #right>
                                <div class="collect" @click="collectFun(good.spuId, good.skuId)">移入<br/>收藏夹</div>
                                <div class="collect del" @click="deleteFun(good.id)">删除</div>
                            </template>
                        </van-swipe-cell>
                    </div>
                </div>
                <div class="cart_activity" v-for="item in activityInfo" :key="item.id" v-show="activityInfo.length && item.merchantCode === shop.merchantCode" >
                    <div class="cart_activity_title">已参加活动</div>
                    <div class="cart_activity_content">
                        <div class="cart_activity_content_left">{{ item.activityName }}</div>
                        <div class="cart_activity_content_right">- <sub>¥ </sub>{{ item.discountAmount }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="emptyMessage" v-else>
            <Empty :emptyInfo='emptyInfo' />
        </div>
        <div class="cart_invalid" v-if="invalidSkus.length">
            <div class="cart_invalid_title"><span @click="onInvalid">清空失效商品</span></div>
            <div v-for="good in invalidSkus" :key='good.id'>
                <van-swipe-cell>
                    <GoodTemplate :isLose='true' :good='good' />
                    <template #right>
                        <div class="collect del" @click="deleteFun(good.id)">删除</div>
                    </template>
                </van-swipe-cell>
            </div>
        </div>
        <div v-if="shops.length">
            <div class="cart_compute" v-if="editShow">
                <div class="cart_compute_checked"><van-checkbox checked-color='#FF7A45' v-model="isSelectedAll" @click="selectAll(shops)">全选</van-checkbox></div>
                <div class="cart_compute_count">合计：<span class="cart_compute_count_price"><sub>¥</sub> {{ totalMoney | NumFormat }}</span><span class="cart_compute_count_num">(共{{ selectedProductsNum }}件商品)</span></div>
                <div class="cart_compute_buttom"><span @click="goAccount">去结算</span></div>
            </div>
            <div class="cart_compute" v-else>
                <div class="cart_compute_checked"><van-checkbox checked-color='#FF7A45' v-model="isSelectedAll" @click="selectAll(shops)">全选</van-checkbox></div>
                <div class="cart_compute_count"><span class="collectColor"  @click="removeCollect">移入收藏夹</span></div>
                <div class="cart_compute_buttom"><span class="delColor" @click="deleteSection">删除</span></div>
            </div>
        </div>
        <Footer ref="cartNum" :menus="menus"></Footer>
        <van-dialog
            v-model="isDialog"
            show='false'
            show-cancel-button
            confirmButtonColor='#FF7A45'
            cancelButtonColor='#FF7A45'
            cancelButtonText='返回'
            title='修改购买数量'
            @confirm="submitDialog"
        >
            <van-field
                ref="vanNum"
                type='number'
                autofocus
                v-model="sumNumber"
                placeholder=""
            />
        </van-dialog>
    </div>
</template>
<script>
import Head from '../../common/head'
import Footer from '../../common/footer'
import GoodTemplate from './components/goodTemplate'
import Empty from '../common/Empty'
import { getcartList, delCart, editShop } from '../api/api'
import { getActivityData } from '../api/activity'
import { addAllCollect } from '../api/product'
import { mapActions } from 'vuex'
import { Dialog, Toast } from 'vant'
import { newCache } from '@/utils/index'
export default {
    name: 'cart',
    components: {
        Head,
        Footer,
        GoodTemplate,
        Empty
    },
    data () {
        return {
            menus: 3, // 底部购物车图标高亮
            headInfo: {
                title: '购物车',
                rightText: '编辑'
            },
            emptyInfo: { // 空页面信息
                iconImg: require('../../../assets/img/b2b/img_empty_cart@2x.png'),
                message: '购物车暂无商品'
            },
            userInfo: null, // 用户基本信息
            showPopover: false, // 促销活动的提示信息
            editShow: true, // 编辑/完成
            isDialog: false, // 是否显示修改购买数量的弹窗
            activityInfo: null, // 获取促销活动信息
            activityPrice: 0, // 促销活动的价格
            shops: [], // 分组后的商品
            invalidSkus: [], // 失效商品
            sumNumber: 0, // 修改的商品数量
            shopIndex: 0, // 店铺的索引
            goodIndex: 0, // 商品的索引
            newDate: '',
            checked: false,
            value: 999,
            selectedProductsNum: 0
        }
    },
    watch: {
        // 计算购物车总商品数
        shops: {
            handler (newVal) {
                let count = 0
                for (let i = 0; i < newVal.length; i++) {
                    let products = newVal[i].skus
                    for (let j = 0; j < products.length; j++) {
                        if (products[j].checked) {
                            count += products[j].quantity
                        }
                    }
                }
                this.selectedProductsNum = count
                this.getActivity()
            },
            immediate: true,
            deep: true
        }
    },
    computed: {
        // 计算勾选的商品总金额
        totalMoney: function () {
            let count = 0
            for (let i = 0; i < this.shops.length; i++) {
                let products = this.shops[i].skus
                for (let j = 0; j < products.length; j++) {
                    if (products[j].checked) {
                        count += products[j].price * products[j].quantity
                    }
                }
            }
            return (count - this.activityPrice).toFixed(2)
        },
        // 购物车中的商品是否全选
        isSelectedAll: {
            get () {
                for (let i = 0; i < this.shops.length; i++) {
                    if (!this.isShopSelectedAll[i]) {
                        return false
                    }
                }
                return true
            },
            // 这里要加一个空的setter，因为用v-model绑定时会报错
            set () {}
        },
        // 店铺中的商品是否全选
        isShopSelectedAll: function () {
            let tempArr = []
            for (let i = 0; i < this.shops.length; i++) {
                tempArr[i] = true
                let products = this.shops[i].skus
                for (let j = 0; j < products.length; j++) {
                    if (!products[j].checked) {
                        tempArr[i] = false
                    }
                }
            }
            return tempArr
        },
        // 获取选中的商品
        checkGoodList: function () {
            let tempArr = []
            for (let i = 0; i < this.shops.length; i++) {
                let products = this.shops[i].skus
                for (let j = 0; j < products.length; j++) {
                    if (products[j].checked) {
                        tempArr.push(products[j])
                    }
                }
            }
            return tempArr
        }
    },
    methods: {
        ...mapActions(['setBuried']), // 埋点
        // 编辑
        onEdit () {
            this.editShow = !this.editShow
            this.headInfo.rightText = this.editShow ? '编辑' : '完成'
            this.setBuried({ event: 20 })
        },
        // 跳转到商品详情页面
        onDetail (goodsId) {
            localStorage.removeItem('goodsId')
            localStorage.setItem('goodsDetailBack', this.$router.history.current.fullPath)
            this.$router.push({ path: '/b2b/goods/goodsDetail', query: { id: goodsId } })
        },
        // 动态的将数量传递给接口，获取新的价格
        async sumCartPrice (good) {
            let maxVal = 0
            if (good.buyLimit) {
                maxVal = good.inventoryNum > good.orderMaxCount ? good.orderMaxCount : good.inventoryNum
            } else {
                maxVal = good.inventoryNum
            }
            if (good.quantity > maxVal) {
                Toast('购买数量已达上限')
                return
            }
            const { data } = await editShop({
                id: good.id,
                memberCode: this.userInfo.companyCode,
                skuId: good.skuId,
                quantity: good.quantity
            })
            good.price = data.price
        },
        // 删除
        deleteSection () {
            if (!this.checkGoodList.length) {
                Toast('还没有选择商品哦')
                return
            }
            let checkGoodLength = this.checkGoodList.length
            let message = checkGoodLength > 1 ? '确定要删除这' + checkGoodLength + '个商品吗？' : '确定要删除该商品吗？'
            this.dialogModel(message, '删除', 1)
        },
        // 移入收藏夹
        removeCollect () {
            if (!this.checkGoodList.length) {
                Toast('还没有选择商品哦')
                return
            }
            let message = '确定是否移入收藏夹？'
            this.dialogModel(message, '确认', 2)
        },
        // 收藏夹接口调用
        async collectFun (spuId, skuId) {
            let arrayId = []
            let type = spuId && skuId ? 2 : 1
            if (spuId && skuId) {
                arrayId.push({ 'skuId': skuId, 'spuId': spuId })
            } else {
                arrayId = this.checkGoodList.map(item => {
                    return {
                        skuId: item.skuId,
                        spuId: item.spuId
                    }
                })
            }
            await addAllCollect({
                memberCode: this.userInfo.companyCode,
                operator: this.userInfo.id,
                skuList: arrayId
            })
            this.getCartListData(type)
        },
        // dialog弹窗
        dialogModel (message, confirmText, type) {
            Dialog.confirm({
                title: '',
                message: message,
                confirmButtonText: confirmText,
                confirmButtonColor: '#FF7A45',
                cancelButtonColor: '#FF7A45'
            }).then(() => {
                if (type === 1) {
                    this.deleteFun()
                } else if (type === 2) {
                    this.collectFun()
                }
            }).catch(() => {})
        },
        // 弹窗数量修改
        onDialog (good, shopIndex, goodIndex) {
            this.sumNumber = good.quantity
            this.shopIndex = shopIndex
            this.goodIndex = goodIndex
            this.isDialog = true
            this.$nextTick(() => {
                this.$refs.vanNum.focus()
            })
        },
        // 修改商品数量提交
        submitDialog () {
            let goodItem = this.shops[this.shopIndex]['skus'][this.goodIndex]
            let maxVal = 0
            if (goodItem.buyLimit) {
                maxVal = goodItem.inventoryNum > goodItem.orderMaxCount ? goodItem.orderMaxCount : goodItem.inventoryNum
            } else {
                maxVal = goodItem.inventoryNum
            }
            if (this.sumNumber > maxVal) {
                Toast('购买数量已达上限')
                goodItem['quantity'] = goodItem.inventoryNum
            } else {
                goodItem['quantity'] = this.sumNumber || 1
            }
        },
        // 清空失效商品
        async onInvalid () {
            let arrayId = this.invalidSkus.map(item => {
                return item.id
            })
            await delCart(arrayId)
            this.getCartListData(2)
            this.setBuried({ event: 22 })
        },
        // 批量删除和单个删除
        async deleteFun (goodId) {
            let arrayId = []
            let type = goodId ? 2 : 1
            if (goodId) { // 判断是批量删除还是单个删除
                arrayId = [goodId]
            } else {
                arrayId = this.checkGoodList.map(item => {
                    return item.id
                })
            }
            await delCart(arrayId)
            this.getCartListData(type)
        },
        // 获取促销活动
        async getActivity () {
            this.activityInfo = null
            this.activityPrice = 0
            if (!this.checkGoodList.length) {
                return
            }
            let shopArr = this.shops.map(item => {
                let skusArr = item.skus.filter(it => it.checked)
                let arr = {
                    merchantCode: item.merchantCode,
                    memberCode: this.userInfo.companyCode,
                    shopCartProducts: skusArr.map(it => {
                        if (it.checked) {
                            return {
                                categoryId: it.categoryId,
                                price: it.price,
                                productId: it.skuId,
                                quantity: it.quantity
                            }
                        }
                    })
                }
                return arr
            })
            const { data } = await getActivityData({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode,
                shopCartList: shopArr
            })
            if (data.length) {
                this.activityPrice = data.reduce((sum, item) => {
                    return sum + item.discountAmount
                }, 0)
            }
            this.activityInfo = data
        },
        // 全选
        // 全选购物车或者单个店家
        selectAll: function (all) {
            // 参数all可传入shops数组或者shops数组内的一个对象
            // all传入shops数组表示购物车中商品全选
            // all传入一个对象表示某个店铺中商品全选
            if (all instanceof Array) {
                let bool = !this.isSelectedAll
                // var bool = false;
                for (let i = 0; i < all.length; i++) {
                    let products = all[i].skus
                    for (let j = 0; j < products.length; j++) {
                        products[j].checked = bool
                    }
                }
            } else {
                let index = this.shops.indexOf(all)
                let bool = this.isShopSelectedAll[index]
                for (let i = 0; i < all.skus.length; i++) {
                    all.skus[i].checked = bool
                }
            }
        },
        // 获取购物车列表数据
        async getCartListData (type) {
            this.$refs.cartNum.onCartNum()
            const { data } = await getcartList({
                merchantCode: this.userInfo.belongMerchantCode,
                memberCode: this.userInfo.companyCode
            })
            let groupData = data.shops || []
            if (!groupData.length) {
                this.headInfo.rightText = ''
            } else {
                groupData.forEach((item, index) => {
                    item.skus.forEach((it, idx) => {
                        if (!index && !idx) {
                            it.checked = true
                        } else {
                            it.checked = false
                        }
                    })
                })
            }
            if (type === 1) {
                this.shops = groupData
                this.invalidSkus = data.invalidSkus || []
            } else {
                if (groupData.length) {
                    groupData.forEach((group, groupIndex) => {
                        this.shops.forEach((shop, shopIndex) => {
                            let result = []
                            if (group.merchantCode === shop.merchantCode) {
                                group.skus.forEach((groupSku, groupIndex) => {
                                    result = shop.skus.filter(cart => cart.id === groupSku.id)
                                    if (result.length) {
                                        groupSku.checked = result[0].checked
                                    }
                                })
                            }
                        })
                    })
                }
                this.shops = groupData
                this.invalidSkus = data.invalidSkus || []
            }
        },
        // 去结算
        goAccount () {
            if (!this.checkGoodList.length) {
                Toast('还没有选择商品哦')
                return
            }
            let shops = JSON.parse(JSON.stringify(this.shops))
            for (let i = 0; i < shops.length; i++) {
                let skus = shops[i].skus
                let shopArr = []
                for (let j = 0; j < skus.length; j++) {
                    if (skus[j].checked) {
                        shopArr.push({
                            shoppingCartId: skus[j].id,
                            skuId: skus[j].skuId,
                            quantity: skus[j].quantity
                        })
                    }
                }
                shops[i].skus = shopArr
            }
            let shopArr = []
            for (let i = 0; i < shops.length; i++) {
                let skus = shops[i].skus
                if (skus.length) {
                    shopArr.push(shops[i])
                }
            }
            localStorage.setItem('goodsData', JSON.stringify(shopArr))
            this.$router.push({ path: '/b2b/order/confirmOrder' })
            this.setBuried({ event: 21 })
        }
    },
    beforeRouteEnter (to, from, next) {
        newCache('cart')
        next()
    },
    beforeRouteLeave (to, from, next) {
        this.$route.meta.isUseCache = true
        next()
    },
    activated () {
        if (this.$route.meta.isUseCache) {
            this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
            this.editShow = true
            this.headInfo.rightText = '编辑'
            // 动态获取购物车列表
            this.getCartListData(2)
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        // 获取购物车列表
        this.getCartListData(1)
    }
}
</script>
<style lang="scss" scoped>
.cart {
    font-size: 28px;
    height: calc(100% - 240px);
    overflow: auto;
    &.cartHeight {
        height: calc(100% - 100px)
    }
    &_list {
        padding: 0 24px;
        box-sizing: border-box;
        &_item {
            margin-top: 20px;
            &_li {
                background: #fff;
                padding: 32px 0 32px 24px;
                border-radius: 12px;
            }
            .topHead {
                margin-bottom: 32px;
            }
            .goodItem {
                margin-bottom: 48px;
                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
    .collect {
        width: 120px;
        height: 100%;
        background: #FF7A45;
        text-align: center;
        box-sizing: border-box;
        color: #fff;
        font-size: 24px;
        line-height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        float: left;
        &.del{
            background: #FF3B30
        }
    }
    &_invalid {
        margin: 20px 24px;
        padding: 24px 0;
        background: #fff;
        border-radius: 12px;
        &_title {
            margin-bottom: 24px;
            padding-right: 24px;
            text-align: right;
            color: #FF7A45;
        }
    }
    &_activity {
        margin: 10px 0 20px;
        background: #fff;
        padding: 24px;
        border-radius: 12px;
        &_title {
            color: #666;
            margin-bottom: 20px;
        }
        &_tip {
            width: 400px;
            padding: 15px 24px;
            font-size: 24px;
            color: #333333;
            text-align: left;
        }
        &_content {
            font-size: 24px;
            display: flex;
            justify-content: space-between;
            &_right {
                color: #FF7A45;
            }
        }
        /deep/ .van-icon {
            font-size: 30px;
            vertical-align: middle;
            color: #999;
            margin-left: 20px;
        }
    }
    &_compute {
        position: fixed;
        bottom: 100px;
        left: 0;
        right: 0;
        border-top: 2px solid #D8D8D8;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 24px;
        height: 128px;
        &_checked {
            flex: 0 0 120px;
        }
        &_count {
            flex: 1;
            text-align: right;
            margin-right: 12px;
            position: relative;
            &_price {
                color: #FF7A45;
                sub {
                    font-size: 20px;
                }
            }
            &_num {
                width: 200px;
                font-size: 20px;
                color: #999;
                position: absolute;
                right: 0;
                top: 35px;
            }
            .collectColor {
                width: 208px;
                height: 64px;
                line-height: 64px;
                border-radius: 64px;
                text-align: center;
                display: inline-block;
                color: #fff;
                background: #FF7A45;
            }
        }
        &_buttom {
            flex: 0 0 208px;
            font-size: 28px;
            span {
                width: 100%;
                height: 64px;
                line-height: 64px;
                border-radius: 64px;
                text-align: center;
                display: inline-block;
                color: #fff;
                background: #FF7A45;
                &.delColor {
                    background: #ff3b30;
                }
            }
        }
        /deep/ .van-checkbox__label {
            margin-left: 12px;
        }
    }
}
// 修改组件的样式
/deep/ .van-checkbox__label {
    margin-left: 24px;
    line-height: inherit;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    white-space: normal;
    word-break: break-all;
}
/deep/ .van-checkbox__icon {
    font-size: 36px;
}
/deep/ .van-swipe-cell__right {
    right: -2px;
}
/deep/ .van-dialog{
    .van-cell__value {
        height: auto;
        input {
            border: 2px solid #cccccc;
            margin: 0 60px;
            padding: 8px;
        }
    }
}
// 店铺图标
/deep/ .iconicon_dianpu {
    font-size: 32px;
    vertical-align: bottom;
    margin-right: 12px;
    color: #999;
}
</style>
